import { useMemo, useState } from "react";
import PropertyImagePlaceholder from "./PropertyImagePlaceholder";
import { reportImageLoadFailure } from "../../utils/imageFailureTelemetry";
import { resolvePublicImageUrl, buildProxiedImageUrl } from "../../utils/resolvePublicImageUrl";

const PropertyImage = ({
  src,
  alt = "",
  className = "",
  imageId = null,
  canonicalPropertyId = null,
  sourceKey = null,
  sourceListingId = null,
  isCached = false,
  cacheStatus = null,
  renderContext = "PROPERTY_CARD",
  pageContext = "REAL_ESTATE_LIST",
  reportTelemetry = true,
}) => {
  const [loadState, setLoadState] = useState("direct");
  const resolvedSrc = useMemo(() => resolvePublicImageUrl(src), [src]);
  const proxiedSrc = useMemo(() => buildProxiedImageUrl(src), [src]);

  if (!resolvedSrc || loadState === "failed") {
    return <PropertyImagePlaceholder />;
  }

  const activeSrc = loadState === "proxy" && proxiedSrc ? proxiedSrc : resolvedSrc;

  const handleError = () => {
    if (loadState === "direct" && proxiedSrc) {
      setLoadState("proxy");
      return;
    }

    setLoadState("failed");

    if (reportTelemetry) {
      reportImageLoadFailure({
        imageId,
        imageUrl: resolvedSrc,
        canonicalPropertyId,
        sourceKey,
        sourceListingId,
        isCached,
        cacheStatus,
        renderContext,
        pageContext,
      });
    }
  };

  return (
    <img
      src={activeSrc}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
      onError={handleError}
    />
  );
};

export default PropertyImage;
